module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1kMc2"))).then(() => module.bundle.root('37nVf'));